module.exports = __webpack_public_path__ + "img/hyperx-pulsefire-surge-preview.de7e8db4.png";